module.exports = __webpack_public_path__ + "img/icon_property.51785b06.jpg";